import { faTrash } from '@fortawesome/pro-solid-svg-icons'
import { HeadingItem } from 'components'
import { ItemDetailInfo } from 'components/item-verification'
import { TripContext } from 'contexts'
import React, { FC, useContext } from 'react'
import { Mispick } from 'services/types'
import './mispicks-card.scss'

type Props = {
    mispickId: number,
    onClickDelete: (id: number) => void,
    onClickEdit: (id: number) => void,
}

export const MispicksCard: FC<Props> = ({ mispickId, onClickDelete, onClickEdit }) => {
    const tripContext = useContext(TripContext)
    const mispicksItem: Mispick = tripContext.mispicks.find(m => m.id === mispickId) ?? {} as Mispick
    return (
        <div className={'card-material'}>
            <HeadingItem text={`Item ID : ${mispicksItem.lineItemId ?? 'N/A'}`}
                rightHandIcon={{ icon: faTrash, size: '1x', color: '#EB5757' }} onClick={() => onClickDelete(mispicksItem.id)} />
            <div className={'mispick-card-content'} onClick={() => onClickEdit(mispicksItem.id)}>
                <ItemDetailInfo title={'UPC'} value={mispicksItem.upc!} position={'left'} />
                <ItemDetailInfo title={'Quantity'} value={mispicksItem.quantity ?? 'N/A'} position={'left'} />
                <ItemDetailInfo title={'Reason'} value={mispicksItem.mispickReason!} position={'left'} />
                {mispicksItem.noReturnStickerReason ?
                    <ItemDetailInfo title={'No Return Sticker'} value={mispicksItem.noReturnStickerReason} position={'left'} />
                    :
                    <ItemDetailInfo title={'Return Sticker'} value={mispicksItem.returnSticker!} position={'left'} />
                }
            </div>
        </div>
    )
}

